import moment from 'moment';

import { DiningOption } from '../types';

export type DiningOptionWithIndex = {
  option: DiningOption;
  optionIndex: number;
};

export type DiningDateGroup = {
  date: string;
  options: DiningOptionWithIndex[];
};

export function groupDiningOptionsByDate(
  diningOptions: DiningOption[],
  fromDate: moment.MomentInput
): DiningDateGroup[] {
  const groups = new Map<string, DiningOptionWithIndex[]>();

  diningOptions.forEach((option, optionIndex) => {
    const date = moment(fromDate)
      .add(option.dayNumber || 0, 'days')
      .format('YYYY-MM-DD');

    const group = groups.get(date);

    if (group) {
      group.push({ option, optionIndex });
    } else {
      groups.set(date, [{ option, optionIndex }]);
    }
  });

  return Array.from(groups.entries())
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([date, options]) => ({ date, options }));
}
